import React, { useState, useRef, useEffect } from "react";

export default function FlagDropdown({ value="DE", onChange }) {
  const locales = [
    { code:"DE", label:"Deutsch", flag:"🇩🇪" }, 
    { code:"EN", label:"English", flag:"🇬🇧" }, 
    { code:"ES", label:"Español", flag:"🇪🇸" }, 
    { code:"FR", label:"Français", flag:"🇫🇷" },
  ];
  const current = locales.find(l => l.code === value) || locales[0];

  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  // Klick außerhalb schließt
  useEffect(() => {
    const onDoc = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div ref={boxRef} style={{ position:"relative" }}>
      {/* Trigger */}
      <button
        onClick={() => setOpen(v => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
        title={`Sprache: ${current.label}`}
        style={{
          display:"inline-flex", alignItems:"center", gap:5,
          borderRadius: 5, padding:"0px 3px",
          border:"1px solid rgba(255,255,255,.14)",
          background:"rgba(0,0,0,.18)", color:"#cfe0ff",
          fontSize:12, fontWeight:700, cursor:"pointer",
        }}
      >
        <span style={{ fontSize:14, lineHeight:1 }}>{current.flag}</span>
        <span>{current.code}</span>
        <span style={{ opacity:.6, marginLeft:2 }}>▾</span>
      </button>

      {/* Menu */}
      {open && (
        <ul
          role="listbox"
          style={{
            position:"absolute", right:0, top:"calc(100% + 6px)",
            minWidth:140, padding:6, margin:0, listStyle:"none",
            borderRadius:10,
            background:"rgba(10,12,18,.92)",
            border:"1px solid rgba(28,46,73,.86)",
            boxShadow:"0 8px 16px rgba(0,0,0,.45)",
            zIndex: 5,
          }}
        >
          {locales.map(loc => (
            <li key={loc.code}>
              <button
                onClick={() => { onChange?.(loc.code); setOpen(false); }}
                role="option"
                aria-selected={loc.code === current.code}
                style={{
                  width:"100%", display:"flex", alignItems:"center", gap:0,
                  padding:"0px 0px", borderRadius:5, cursor:"pointer",
                  border:"none", background:"transparent", color:"#e6edf3",
                  fontSize:12,
                }}
              >
                <span style={{ fontSize:14 }}>{loc.flag}</span>
                <span style={{ flex:1 }}>{loc.label}</span>
                {loc.code === current.code && <span style={{ opacity:.65 }}>✓</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
